export var authCookieOptions = function authCookieOptions(minutes) {
  return {
    expires: new Date(new Date().getTime() + minutes * 60 * 1000)
  };
};